import React, {Component} from 'react';
import {
    Button,
    Col,
    DropdownButton, Image,
    MenuItem,
    OverlayTrigger,
    Row,
    ToggleButton,
    ToggleButtonGroup,
    InputGroup,
    FormControl
} from 'react-bootstrap';
import {Creatable} from 'react-select'
import {SketchPicker} from 'react-color';
import Colour_Picker from '../../components/Colour_Picker';
import reactCSS from 'reactcss';
import tooltips from "../../components/Tooltips";
import DropdownMenu from 'react-bootstrap/lib/DropdownMenu';

class TextOptionsPanel extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            displayColorPicker: false,
            text_color : "#000000",
            bulk_edit_label_temp: "",
            bulk_edit_open: false
        }
    }

    
    handleLabelChange = (e) => {
        this.setState({bulk_edit_label_temp: e.target.value});
    }

    handleSpaceBar = (e) => {
        if(e.key == " "){
            e.preventDefault();
            e.stopPropagation();
            this.setState({bulk_edit_label_temp: this.state.bulk_edit_label_temp + " "});
        }
    }

    get_current_label = () => {
        if(this.props.design_selection && this.props.design_selection.user_labels && this.props.design_selection.user_labels["text"]){
            var label_id = this.props.design_selection.user_labels["text"];
            var label_find = window.design_editor.design.bulk_edit_data.labels.find(o => {return o.id == label_id})
            if(label_find){
                return label_find.text
            }
        }
        return "";
    }

    bulk_edit_on_click = async () => {
        if(this.get_current_label() == "" && this.state.bulk_edit_label_temp != ""){
            if(this.props.design_selection && this.props.design_selection.user_labels && this.props.design_selection.user_labels["text"]!=undefined){
                var new_label_id = window.utils.uuidv4()
                window.design_editor.design.bulk_edit_data.labels.push({
                    id: new_label_id, text: this.state.bulk_edit_label_temp, assigned: [this.props.design_selection.id], selected: true, type: 'text'
                });
                
                this.props.design_selection.user_labels["text"] = new_label_id;
                window.design_editor.addUndoChange()
            }
            this.setState({});
        }

        await this.props.switch_nav_tab("");
        await this.props.switch_nav_tab("bulk_edit");
    }

    bulk_edit_toggle = (isOpen, e) => {
        if(e.target.type != 'text'){
            this.setState({bulk_edit_open:isOpen})
        }
    }

    componentDidMount() {
        this.setState({bulk_edit_label_temp:""});
    }

    componentWillUnmount() {
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
      };
    
    handleClose = () => {
        this.setState({ displayColorPicker: false })
      };

    get_align_button_number = () => {
        if(this.props.design_selection&&this.props.design_selection.text_details.textAlign){
            if(this.props.design_selection.text_details.textAlign == 'left'){
                return "fa fa-align-left"
            }else if(this.props.design_selection.text_details.textAlign == 'center'){
                return "fa fa-align-center"
            }else if(this.props.design_selection.text_details.textAlign == 'right'){
                return "fa fa-align-right"
            }else{
                return "fa fa-align-right"
            }
        }else{
            return "fa fa-align-left"
        }
    }

    render() {
        
        const styles = reactCSS({
            'default': {
              color: {
                width: '30px',
                height: '30px',
                borderRadius: '15px',
                'border': '1px',
                background: this.props.design_selection?this.props.design_selection.text_details.fontColor:'#ff0000',
              },
              swatch: {
                padding: '2.5px',
                borderRadius: '15px',
                cursor: 'pointer',
              },
              popover: {
                position: 'absolute',
                zIndex: '2',
              },
              cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
                zIndex: '-1'
              },
            },
          });

        return (
            <Row style={{backgroundColor: '#F1F2F3', paddingTop: 5, paddingBottom: 5, zIndex :1010}}>
                <Col xs={7} style={{'display':'flex','flexFlow':'row',zIndex:"10000"}}>
                    <div style={{marginRight:'5px'}}>
                        <div style={ styles.swatch } onClick={ this.handleClick }>
                        <div style={ styles.color } />
                        </div>
                        { this.state.displayColorPicker ? <div style={ styles.popover }>
                        <div style={ styles.cover } onClick={ this.handleClose }/>
                        <Colour_Picker user={this.props.user}  presetColors={['#ffffff','#f3ec3a','#f9bd17','#f99b1d','#f15523','#ef3124','#DE0081','#a71e48','#7c3597','#463191','#000000','#3d5dac','#1296ce','#63b145','#19BC81','#d0dd36']} disableAlpha={true} color={this.props.design_selection?this.props.design_selection.text_details.fontColor:'#000000'} onChange={ (e) => {this.props.update_inputs_text(e,'color') }} />
                        </div> : null }
                    </div>
                    <Button 
                        style={{
                            fontFamily: this.props.design_selection&&this.props.design_selection.type=='text'?this.props.design_selection.text_details.font:'',
                            boxShadow: 'none',
                            background: 'white',
                            minWidth: '100px',
                            height: 36,
                            marginRight: '5px'
                        }}
                        onClick={(e) => this.props.switch_nav_tab('fonts')}
                    >
                        {this.props.design_selection&&this.props.design_selection.type=='text'?this.props.design_selection.text_details.font:''}
                        <span style={{float: 'right', 'marginTop' : 7}} className="caret"></span>
                    </Button>

                    <Creatable
                        label="Single select"
                        options={this.props._font_sizes}
                        defaultValue={this.props._font_sizes[2]}
                        styles = {this.props._font_styles}
                        value={this.props.design_selection?{label: Math.floor(this.props.design_selection.text_details.fontSize),value: this.props.design_selection.text_details.fontSize}:''}
                        onChange={(e) => {this.props.update_inputs_text(e,'fontSize')}}
                        isValidNewOption = {(inputValue, selectValue, selectOptions) => !isNaN(Number(inputValue))&&Number(inputValue)!=0&&!this.props._font_sizes.find(o => o.value==inputValue)?true:false}
                        formatCreateLabel = {(inputValue, selectValue, selectOptions) => inputValue}
                    />
                    
                    <ToggleButtonGroup type='checkbox' style={{marginRight:"3px"}} onChange={(e) => {this.props.update_inputs_text(e,'bold')}} value={this.props.design_selection&&this.props.design_selection.text_details.bold?[1]:[]} >
                        <ToggleButton value={1} className="btn-toolbar"><span className="fas fa-bold" style={{verticalAlign:"bottom"}}></span></ToggleButton>
                    </ToggleButtonGroup>

                    <ToggleButtonGroup type='checkbox' style={{marginRight:"3px"}} onChange={(e) => {this.props.update_inputs_text(e,'italic')}} value={this.props.design_selection&&this.props.design_selection.text_details.italic?[1]:[]}>
                        <ToggleButton value={1} className="btn-toolbar"><span className="fas fa-italic" style={{verticalAlign:"bottom"}}></span></ToggleButton>
                    </ToggleButtonGroup>
                    <Button className="btn-toolbar btn-toolbar-square" style={{'marginRight': '5px', 'backgroundImage': 'none', 'border': 'none'}} onClick={(e) => {this.props.update_inputs_text('','textAlign')}} ><span className={this.get_align_button_number()}></span></Button>
                    <DropdownButton
                        pullLeft={true}
                        className="btn-toolbar" 
                        style={{'marginRight': '5px'}}                    
                        title="Spacing"
                        >
                        <MenuItem className="disable-hover-bg" style={{paddingTop:"10px",paddingBottom:"10px",width:'300px'}} draggable="false">
                            <div style={{display:'flex',flexFlow:'row'}}>
                                <p style={{margin:'auto',display:'block'}}>Letter Spacing</p>
                                <div>
                                    <input style={{paddingLeft:'10px',paddingRight:'10px'}}className="disable-hover-bg" type="range" min="-30" max="30" id="letter_space_slider" onChange={(e) => {this.props.update_inputs_text(e.target.value,'letterSpacing')}} value={this.props.design_selection&&this.props.design_selection.text_details.letterSpacing?String(this.props.design_selection.text_details.letterSpacing):"0"}  />
                                </div>
                                <p style={{margin:'auto',display:'block'}}>{this.props.design_selection&&this.props.design_selection.text_details.letterSpacing?String(Math.round(this.props.design_selection.text_details.letterSpacing)):"0"}</p>
                            </div>
                        </MenuItem>
                        <MenuItem className="disable-hover-bg" style={{paddingTop:"10px",paddingBottom:"10px"}} draggable="false">
                            <div style={{display:'flex',flexFlow:'row'}}>
                                <p style={{margin:'auto',display:'block'}}>Line Height</p>
                                <div>
                                    <input style={{paddingLeft:'10px',paddingRight:'10px'}}className="disable-hover-bg" type="range" min="-30" max="30" id="line_height_slider" onChange={(e) => {this.props.update_inputs_text(e.target.value,'lineHeight')}} value={this.props.design_selection&&this.props.design_selection.text_details.lineHeight?String(this.props.design_selection.text_details.lineHeight):"0"}  />
                                </div>
                                <p style={{margin:'auto',display:'block'}}>{this.props.design_selection&&this.props.design_selection.text_details.lineHeight?String(Math.round(this.props.design_selection.text_details.lineHeight)):"0"}</p>
                            </div>
                        </MenuItem>
                    </DropdownButton>
                    <Button className="btn-toolbar" style={{'marginLeft': '5px',}} onClick={this.props.textEffectsPanelOnclick}>Effects</Button>
                    {global.config.application_env != "" && (<OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['animate']}>
                        <Button className="btn-toolbar" onClick={() => this.props.animateOnClick("text")} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                            <Image style={{ height: 20 }} src={null} />
                            Animate
                        </Button>
                    </OverlayTrigger>)}
                    <DropdownButton
                        pullLeft={true}
                        className="btn-toolbar" 
                        style={{'marginRight': '5px'}}                    
                        title="Bulk Label"
                        open={this.state.bulk_edit_open}
                        onToggle={this.bulk_edit_toggle}
                        >
                            <MenuItem className="disable-hover-bg" style={{paddingTop:"10px",paddingBottom:"10px",width:'300px'}} draggable="false">
                                <Row>
                                    <Col xs={2}>
                                        <Image style={{ height: 30, float:"right"}} src={global.config.static_file_server_path + 'uploads/icons/Text.svg'} />
                                    </Col>
                                    <Col xs={10} style={{paddingLeft:0, paddingRight:0}}>
                                        {/* <InputGroup style={{border: "1px solid grey",width:"100%"}}> */}
                                            {this.get_current_label()==""?(<input
                                                key={"create_new_label"}
                                                value={this.state.bulk_edit_label_temp}
                                                style={{border: "1px solid grey",width:"100%",fontSize: 14, fontFamily: 'Montserrat', height: 30, borderRadius: 0}}
                                                placeholder={'Enter a label'}
                                                type="text"
                                                onKeyUp={(e) => this.handleSpaceBar(e)}
                                                onChange={(e) => this.handleLabelChange(e)}
                                            />):(<input
                                                key={"manage_labels"}
                                                style={{border: "1px solid grey",width:"100%",fontSize: 14, fontFamily: 'Montserrat', height: 30, borderRadius: 0}}
                                                placeholder={'Enter a label'}
                                                value={this.get_current_label()}
                                                type="text"
                                                disabled={true}
                                                // onChange={(e) => handleChange(id, e)}
                                            />)}
                                        {/* </InputGroup> */}
                                    </Col>
                                </Row>
                            </MenuItem>
                            <MenuItem className="disable-hover-bg" style={{display:"flex",justifyContent:"center",paddingTop:"10px",paddingBottom:"10px"}} draggable="false">
                                <Button onClick={this.bulk_edit_on_click} className="btn btn-sm btn-block btn-orange" style={{textAlign: 'center'}}>{this.get_current_label()!=""?"Manage Labels":" OK "}</Button>
                            </MenuItem>
                    </DropdownButton>
                </Col>
                
                {this.props._rhs_options_panel(5)}
            </Row>
        );
    }
}

export default TextOptionsPanel;